import React, { useEffect, useState } from "react";
import API from "./axios"; // ← your axios.js config

export default function UserProfile() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    API.get("/user")
      .then((res) => setUser(res.data))
      .catch((err) => {
        console.error("Not logged in", err);
        // optionally redirect to login page
      });
  }, []);

  if (!user) return <p>Loading or not authenticated...</p>;

  return (
    <div>
      <h2>Welcome, {user.name}</h2>
      <p>Email: {user.email}</p>
    </div>
  );
}
